import React from 'react';
import { Box, Container, List, ListItem, Typography } from '@mui/material';
import HeaderLogo from 'src/components/customecomponent/HeaderLogo';
import Footer from 'src/components/customecomponent/Footer';

const PrivacyPolicy = () => {
  let today = new Date();
  today.setMonth(today.getMonth() - 6);
  const formattedDate = today.toISOString().split('T')[0];

  return (
    <>
      <Box sx={{ pb: 3 }}>
        {/* Logo */}
        <HeaderLogo />
        {/* Content Container */}
        <Container sx={{ maxWidth: '75% !important' }}>
          <Box sx={{ p: 3 }}>
            <Typography variant="h3" align="center">
              Privacy Policy
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Last updated: {formattedDate}
          </Typography>

          {/* Privacy Policy Sections */}
          <Box>
            <Typography variant="h6" sx={{ mt: 2 }}>
              1. Introduction
            </Typography>
            <Typography variant="body1">
              Welcome to Mevelsurvey. We value your privacy and are dedicated to protecting your personal
              information. This policy explains how we collect, use, and safeguard your data when you use our services.
              By accessing our website or services, you agree to the practices outlined in this policy.
            </Typography>

            <Typography variant="h6" sx={{ mt: 2 }}>
              2. Information We Collect
            </Typography>
            <Typography variant="body1">
              We collect personal information that you provide to us directly when you interact with our website or
              services. This may include your name, email address, phone number, project details, and any other relevant
              information. Additionally, we may gather non-personal data like IP addresses or browser types to enhance
              your user experience.
            </Typography>

            <Typography variant="h6" sx={{ mt: 2 }}>
              3. How We Use Your Information
            </Typography>
            <List sx={{ pl: 5 }}>
              <ListItem>To provide and improve our services</ListItem>
              <ListItem>To communicate with you regarding inquiries and projects</ListItem>
              <ListItem>To comply with legal obligations</ListItem>
            </List>

            <Typography variant="h6" sx={{ mt: 2 }}>
              4. Data Protection
            </Typography>
            <Typography variant="body1">
              We take your privacy seriously and implement robust security measures to protect your personal data from
              unauthorized access, alteration, or disclosure. While we strive to keep your information secure, please
              note that no method of online transmission or storage is completely invulnerable, and we cannot guarantee
              absolute security.
            </Typography>

            <Typography variant="h6" sx={{ mt: 2 }}>
              5. Third-Party Sharing
            </Typography>
            <Typography variant="body1">
              We do not sell, trade, or rent your personal information to third parties. However, in the course of
              providing our services, we may share your data with trusted third-party service providers who assist with
              tasks such as billing, customer support, or project management. These third parties are obligated to
              safeguard your information and use it only for the purposes for which it was provided.
            </Typography>

            <Typography variant="h6" sx={{ mt: 2 }}>
              6. Your Rights
            </Typography>
            <Typography variant="body1">
              As a user, you have the right to request access to, corrections to, or deletion of your personal data. If
              you wish to exercise any of these rights or have concerns about how your data is being used, please
              contact us at the provided contact details. We will respond to your request in accordance with applicable
              privacy laws.
            </Typography>

            <Typography variant="h6" sx={{ mt: 2 }}>
              7. Changes to This Policy
            </Typography>
            <Typography variant="body1">
              We may update our privacy policy from time to time to reflect changes in our practices or legal
              requirements. Any changes will be posted on this page, with an updated "Effective Date" at the top. We
              encourage you to review this policy periodically to stay informed about how we are protecting your
              information.
            </Typography>

            <Typography variant="h6" sx={{ mt: 2 }}>
              8. Contact Us
            </Typography>
            <Typography variant="body1">
              If you have any questions, concerns, or requests regarding our privacy policy or how we handle your data,
              please do not hesitate to reach out to us at <strong>info@meveltech.com</strong>.We are here to
              assist you and address any privacy-related inquiries.
            </Typography>
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
